// extracted by mini-css-extract-plugin
export var button = "_ca-2";
export var iconWrapper = "_ca-0";
export var investigatingIcon = "_ca-1";